module.exports = __webpack_public_path__ + "img/miniprogram.5353389d.png";